import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
// import { useStore } from 'src/stores';
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Icon, ExpandedTooltip } from '@livable/saas-react-components';
import { SimpleConfirmationModal } from '../SimpleConfirmationModal';
import { BigWarningAlert } from 'src/components/general/BigAlerts';
import { Typography, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';
// import DOMPurify from 'dompurify';

export const PropertyPortfolioTagLabel = observer(_ref => {
  let iconName = _ref.iconName,
    labelText = _ref.labelText,
    isRemoveBtn = _ref.isRemoveBtn,
    removeBtnText = _ref.removeBtnText,
    propertyAddress = _ref.propertyAddress,
    removeActionCallback = _ref.removeActionCallback,
    isAddNew = _ref.isAddNew,
    addNewActionCallback = _ref.addNewActionCallback,
    _ref$isLoaderPlacehol = _ref.isLoaderPlaceholder,
    isLoaderPlaceholder = _ref$isLoaderPlacehol === void 0 ? false : _ref$isLoaderPlacehol;
  const classes = useStyles();
  // const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isRemoveConfirmationModalOpen = _React$useState2[0],
    setIsRemoveConfirmationModalOpen = _React$useState2[1];
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.container, " ").concat(!isRemoveBtn && !isAddNew ? 'defaultPortfolio' : '', " ").concat(isLoaderPlaceholder && 'loaderPlaceholder'),
    onClick: event => {
      if (isAddNew && addNewActionCallback && !isLoaderPlaceholder) {
        event.preventDefault();
        event.stopPropagation();
        addNewActionCallback(event);
      }
    }
  }, isLoaderPlaceholder ? /*#__PURE__*/React.createElement(Skeleton, {
    variant: "text",
    animation: "wave",
    height: 34,
    width: '100%'
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.icon)
  }, /*#__PURE__*/React.createElement(Icon, {
    type: isAddNew ? 'plus' : iconName
  })), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: labelText,
    type: "grey"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.labelData)
  }, labelText)), isRemoveBtn && !isAddNew && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    placement: "top",
    title: removeBtnText,
    type: "grey"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => {
      setIsRemoveConfirmationModalOpen(true);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "error",
    state: "grey"
  }))), /*#__PURE__*/React.createElement(SimpleConfirmationModal, {
    key: "UnassignPortfolioModal-PropertyPortfolioTagLabel",
    externalIsOpen: isRemoveConfirmationModalOpen,
    headerText: t('add_new_property_flow.remove_property_from_portfolio_title'),
    subTitleText: propertyAddress,
    callBack: data => {
      setIsRemoveConfirmationModalOpen(false);
      if (data.action === 'submit') {
        removeActionCallback();
      }
    },
    customSubmitButtonName: t('general.remove'),
    bodyComponent: /*#__PURE__*/React.createElement(BigWarningAlert, null, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4"
    }, t('add_new_property_flow.remove_property_from_portfolio_description', {
      propertyAddress: propertyAddress,
      portfolioName: labelText
    }))),
    customTrigger: null
  })))));
});